import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';
import { Http } from '@angular/http';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';

export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, '/assets/lang', '.json');
}

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot(
      {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    ),
    Angular2FontawesomeModule
  ],
  declarations: [],
  exports: [
    TranslateModule,
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts